/**
 * Tone → Tailwind classes for tinted chips, icons and values. One place to keep color meaning
 * consistent: brand = neutral emphasis, success = good, warning = attention, danger = bad.
 */
export const TONES = {
    brand: { chip: 'bg-primary-50 text-primary-600', text: 'text-primary-600', solid: 'bg-primary-600', ring: 'ring-primary-100' },
    success: { chip: 'bg-success-bg text-success-fg', text: 'text-success-fg', solid: 'bg-success-solid', ring: 'ring-success-border' },
    warning: { chip: 'bg-warning-bg text-warning-fg', text: 'text-warning-fg', solid: 'bg-warning-solid', ring: 'ring-warning-border' },
    danger: { chip: 'bg-danger-bg text-danger-fg', text: 'text-danger-fg', solid: 'bg-danger-solid', ring: 'ring-danger-border' },
    info: { chip: 'bg-info-bg text-info-fg', text: 'text-info-fg', solid: 'bg-info-solid', ring: 'ring-info-border' },
    violet: { chip: 'bg-violet-bg text-violet-fg', text: 'text-violet-fg', solid: 'bg-violet-solid', ring: 'ring-violet-border' },
    neutral: { chip: 'bg-surface-100 text-surface-600', text: 'text-surface-700', solid: 'bg-surface-500', ring: 'ring-surface-200' }
};

export const tone = (name) => TONES[name] || TONES.neutral;
